module.exports = __webpack_public_path__ + "img/enfp.df800957.png";